import Render from '@Views/components/stripe-subscription-cancel-alert.html'
import { Vue, Component} from 'vue-property-decorator'

@Render
@Component({})
export class StripeSubscriptionCancelAlert extends Vue {
}
